import { render, staticRenderFns } from "./BuildingActions.vue?vue&type=template&id=bf7c0a62&scoped=true"
import script from "./BuildingActions.vue?vue&type=script&lang=js"
export * from "./BuildingActions.vue?vue&type=script&lang=js"
import style0 from "./BuildingActions.vue?vue&type=style&index=0&id=bf7c0a62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7c0a62",
  null
  
)

export default component.exports